export const OnboardingStep = [
  'CommerceInformation',
  'CommerceAddress',
  'CommerceBranches',
  'CommerceBeneficiaries',
  'CommerceBankAccount',
  'CommerceConditions',
  'CommerceTerminals',
  'CommerceCodes',
  'CommerceDocumentation',
  'CommerceSummary',
] as const;

const totalSteps = OnboardingStep.length;

export const getProgressPercentage = (currentStepName: (typeof OnboardingStep)[number]) => {
  const currentStep = OnboardingStep.indexOf(currentStepName) + 1;
  return (currentStep / totalSteps) * 100;
};
